<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        :video-url="videoUrl"
        :video-titulo="$t('mensajes.central_reservas.ayuda_contenido.expedientes')"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaExpedientes',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#1976D2'
        }
    },
    computed: {
        videoUrl() {
            const videosPorIdioma = {
                es: 'https://share.synthesia.io/embeds/videos/cc2a2038-a3f9-45d6-8f5c-c86703a71c50',
                en: 'https://share.synthesia.io/embeds/videos/ef53cb41-94a6-4de6-8bb7-763550405abd'
            };

            const idiomaVideo = this.$i18n.locale === 'de' ? 'en' : this.$i18n.locale;
            return videosPorIdioma[idiomaVideo] || videosPorIdioma.es;
        },
        faqs() {
            return [
                {
                    id: 1,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.1.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.1.respuesta')
                },
                {
                    id: 2,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.2.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.2.respuesta')
                },
                {
                    id: 3,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.3.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.3.respuesta')
                },
                {
                    id: 4,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.4.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.4.respuesta')
                },
                {
                    id: 5,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.5.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.5.respuesta')
                },
                {
                    id: 6,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.6.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.expedientes.6.respuesta')
                }
            ];
        }
    }
};
</script>
